/**
 * Created by andrey on 08.08.2025
 */

cc.JumpTo = function (duration, position, y, height, jumps) {
    cc.JumpBy.prototype.constructor.call(this);

    this._endPosition = cc.p(0, 0);
    if (height !== undefined) {
        this.initWithDuration(duration, position, y, height, jumps);
    }
};

cc.JumpTo.prototype = Object.assign(Object.create(cc.JumpBy.prototype), {
    constructor: cc.JumpTo,

    initWithDuration: function (duration, position, y, height, jumps) {
        if (cc.JumpBy.prototype.initWithDuration.call(this, duration, position, y, height, jumps)) {
            if (jumps === undefined) {
                y = position.y;
                position = position.x;
            }
            this._endPosition.x = position;
            this._endPosition.y = y;
            return true;
        }
        return false;
    },

    startWithTarget: function (target) {
        cc.JumpBy.prototype.startWithTarget.call(this, target);
        this._delta.x = this._endPosition.x - this._startPosition.x;
        this._delta.y = this._endPosition.y - this._startPosition.y;
    }
});

cc.jumpTo = (duration, position, y, height, jumps) => new cc.JumpTo(duration, position, y, height, jumps);
